import React from 'react';
import { useNavigate } from 'react-router-dom';
import VoxSmythIcons from './VoxSmythIcons';

const InvitationChoicePage = () => {
  const navigate = useNavigate();

  const handleCreatorPath = () => {
    navigate('/creator-intake');
  };

  const handleListenerPath = () => {
    navigate('/request-invitation');
  };

  const handleBackToHome = () => {
    navigate('/');
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: `linear-gradient(135deg, 
        #1A202C 0%, 
        #2D3748 25%, 
        #1A202C 50%, 
        #2D3748 75%, 
        #1A202C 100%
      )`,
      backgroundSize: '400% 400%',
      animation: 'gradient-shift 12s ease infinite',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      fontFamily: 'DM Sans, sans-serif'
    }}>
      {/* Back to Home Button */}
      <button
        onClick={handleBackToHome}
        style={{
          position: 'absolute',
          top: '20px',
          left: '20px',
          background: 'transparent',
          border: '1px solid #D7B377',
          color: '#D7B377',
          padding: '8px 16px',
          borderRadius: '8px',
          fontSize: '14px',
          fontWeight: '600',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          transition: 'all 0.3s ease'
        }}
        onMouseOver={(e) => {
          e.target.style.background = '#D7B377';
          e.target.style.color = '#1A202C';
        }}
        onMouseOut={(e) => {
          e.target.style.background = 'transparent';
          e.target.style.color = '#D7B377';
        }}
      >
        <VoxSmythIcons.Home size={16} />
        Back to Home
      </button>

      {/* Main Content */}
      <div style={{
        background: 'rgba(45, 55, 72, 0.95)',
        backdropFilter: 'blur(10px)',
        borderRadius: '20px',
        padding: '40px',
        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.3)',
        border: '1px solid rgba(215, 179, 119, 0.2)',
        maxWidth: '600px',
        width: '100%',
        textAlign: 'center'
      }}>
        {/* Header */}
        <div style={{ marginBottom: '30px' }}>
          <VoxSmythIcons.Mail size={48} color="#D7B377" />
          <h1 style={{
            fontSize: '2.5rem',
            fontWeight: '700',
            color: '#D7B377',
            marginBottom: '12px',
            fontFamily: 'DM Serif Display, Georgia, serif'
          }}>
            Choose Your Path
          </h1>
          <p style={{
            color: '#E2E8F0',
            fontSize: '1.1rem',
            lineHeight: '1.6',
            opacity: 0.9
          }}>
            Select the option that best describes your interest in VoxSmyth
          </p>
        </div>

        {/* Two Options */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '20px',
          marginBottom: '30px'
        }}>
          {/* Creator Path */}
          <div
            onClick={handleCreatorPath}
            style={{
              background: 'linear-gradient(135deg, #D7B377 0%, #E2D7C4 100%)',
              color: '#1A202C',
              padding: '30px 20px',
              borderRadius: '16px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 8px 24px rgba(215, 179, 119, 0.3)',
              border: 'none',
              position: 'relative',
              overflow: 'hidden'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translateY(-4px)';
              e.currentTarget.style.boxShadow = '0 12px 32px rgba(215, 179, 119, 0.4)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 8px 24px rgba(215, 179, 119, 0.3)';
            }}
          >
            <VoxSmythIcons.Crown size={32} color="#1A202C" />
            <h3 style={{
              fontSize: '1.4rem',
              fontWeight: '700',
              marginBottom: '12px',
              marginTop: '16px'
            }}>
              I'm a Creator
            </h3>
            <p style={{
              fontSize: '0.95rem',
              lineHeight: '1.5',
              opacity: 0.8,
              marginBottom: '16px'
            }}>
              Join as a content creator, voice actor, or storyteller
            </p>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              fontSize: '0.9rem',
              fontWeight: '600'
            }}>
              Creator Application
              <VoxSmythIcons.ArrowRight size={16} />
            </div>
          </div>

          {/* Listener Path */}
          <div
            onClick={handleListenerPath}
            style={{
              background: 'rgba(255, 255, 255, 0.1)',
              color: '#E2E8F0',
              padding: '30px 20px',
              borderRadius: '16px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
              border: '1px solid rgba(215, 179, 119, 0.3)',
              position: 'relative',
              overflow: 'hidden'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translateY(-4px)';
              e.currentTarget.style.boxShadow = '0 12px 32px rgba(0, 0, 0, 0.3)';
              e.currentTarget.style.background = 'rgba(255, 255, 255, 0.15)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 8px 24px rgba(0, 0, 0, 0.2)';
              e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
            }}
          >
            <VoxSmythIcons.User size={32} color="#E2E8F0" />
            <h3 style={{
              fontSize: '1.4rem',
              fontWeight: '700',
              marginBottom: '12px',
              marginTop: '16px'
            }}>
              I'm a Listener
            </h3>
            <p style={{
              fontSize: '0.95rem',
              lineHeight: '1.5',
              opacity: 0.8,
              marginBottom: '16px'
            }}>
              Join as a reader who wants access to premium audiobooks
            </p>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              fontSize: '0.9rem',
              fontWeight: '600'
            }}>
              Request Invitation
              <VoxSmythIcons.ArrowRight size={16} />
            </div>
          </div>
        </div>

        {/* Additional Info */}
        <div style={{
          background: 'rgba(215, 179, 119, 0.1)',
          padding: '20px',
          borderRadius: '12px',
          marginTop: '20px'
        }}>
          <p style={{
            color: '#D7B377',
            fontSize: '0.9rem',
            lineHeight: '1.5',
            margin: 0
          }}>
            <strong>Not sure which path to choose?</strong> Listeners can always upgrade to Creator status later. 
            Creators have access to all listener features plus content creation tools.
          </p>
        </div>
      </div>
    </div>
  );
};

export default InvitationChoicePage;